import { Controller } from "@hotwired/stimulus"

/** Swaps struck-through plan prices between monthly and yearly billing. */
export default class extends Controller {
  static targets = ["option", "price"]

  select(event) {
    const interval = event.currentTarget.dataset.interval

    this.optionTargets.forEach((button) => {
      const active = button.dataset.interval === interval
      button.classList.toggle("is-active", active)
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })

    this.priceTargets.forEach((node) => {
      const label = interval === "year" ? node.dataset.priceYear : node.dataset.priceMonth
      if (label) node.textContent = label
    })
  }
}
